var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "anchor-reviews" } },
    [
      _vm.loading
        ? _c("div", [_c("device-average-rating-reviews-skeleton")], 1)
        : [
            _c("div", { staticClass: "bg-gray2 py-2 mb-2" }, [
              _c(
                "div",
                { staticClass: "row mx-0" },
                [
                  _vm.reviewsStatsAverage
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-12 col-md-6 d-md-flex justify-content-center",
                          class: _vm.hasAverageRatings
                            ? "border-end border-gray4"
                            : null,
                        },
                        [
                          _c("device-rating-reviews", {
                            attrs: {
                              title: _vm.reviewsMessages.ratingTitle,
                              "link-label": _vm.reviewsMessages.ratingLinkLabel,
                              "link-url": _vm.reviewsMessages.ratingLinkUrl,
                              average: _vm.reviewsStatsAverage,
                              text: _vm.reviewsStatsText,
                              "rating-results-height": 1.375,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasAverageRatings
                    ? [
                        _c(
                          "div",
                          { staticClass: "col-12 d-md-none" },
                          [_c("ob1-separateur", { staticClass: "my-2" })],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-6 d-md-flex justify-content-center",
                          },
                          [
                            _c("reviews-average-ratings", {
                              attrs: {
                                subtitle:
                                  _vm.reviewsMessages.averageRatingsSubtitle,
                                "average-ratings": _vm.averageRatings,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }